import { IonLabel, IonList, IonListHeader } from '@ionic/react';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { DqText } from 'src/components/dq-text';
import { ControllerMessages } from 'src/intl/ControllerMessages';
import { selectBleBundleFiles } from 'src/redux/ble/selectors';
import { ControllerInfoBundleCard } from './ControllerInfoBundleCard';

export const ControllerInfoBundleList: React.FC = props => {
  const bundleFiles = useSelector(selectBleBundleFiles);

  return bundleFiles.length > 0 ? (
    <IonList lines="none">
      <IonListHeader>
        <IonLabel>
          <DqText variant="h2">
            <FormattedMessage {...ControllerMessages.installedBundlesListHeader} />
          </DqText>
        </IonLabel>
      </IonListHeader>
      {bundleFiles.map(file => {
        return <ControllerInfoBundleCard key={file.bundleId} file={file} />;
      })}
    </IonList>
  ) : null;
};
